const ADMIN_TOKENS = [
  'RjBEAiB67OtjU74CamemnW4VQjWZr6SqPjC29hYDXDwTm1QiwQIgf3XKFYuWQtQ7e2XgLM4CHkbxqaStebJxaPNOBVXcuZR7InUiOjEsImUiOiIyMDMwLTEyLTMwVDE4OjMwOjAwLjAwMCswMDowMCJ9',
  'RjBEAiB3jEiw-2Xz75aXgzPmVsP4_5GRxi21ZqhgY2f6wb1bKAIgHWkC0FO41o5mVPVfLfO_b5KE7EMKRSVtf_u7-CPZ0Jp7InUiOjIsImUiOiIyMDMwLTEyLTMwVDE4OjMwOjAwLjAwMCswMDowMCJ9',
  'RjBEAiAA9U7qgxwY1_3KPI5OKcpZCWeNdA-e0CbNrQECrDeicwIgIKc_CgqK8cxMmrukncTyNiWod7G_lVLrU8Bcd72zuax7InUiOjMsImUiOiIyMDI4LTEyLTIxVDE4OjMwOjAwLjAwMCswMDowMCJ9',
  'SDBGAiEAp3ZeCyT8dfvkZ-AiTzDcNTuElRg0aPzYfVLVOg2VM-MCIQC_QGb8640wwbomlYfDkCEV8PDkOv4--iouCDFMZ8yxdXsidSI6NTksImUiOiIyMDMwLTEyLTMwVDE4OjMwOjAwLjAwMCswMDowMCJ9',
  'RzBFAiEA_zYl8A9p-AGbRSEc_3QRN-wF037Cew_hiuKVMysmyeICIGH7q9OdFFXVQOTN5DK4Q_A2uULsneN8vcDTmYb7TW5LeyJ1Ijo2MSwiZSI6IjIwMzAtMDEtMDhUMTg6MzA6MDAuMDAwKzAwOjAwIn0'
];

const AREA_TOKENS = {
  'argada': 'RzBFAiEA-udgjTQsuHyxT_TtlEo9I_TyW9JT54NwSzuYyGgfFUICIGotoD7xU7C2CJD7q22OV2zEPmbYURtlhSUHOX2yg5TOeyJ1Ijo1LCJlIjoiMjAzMC0xMi0zMFQxODozMDowMC4wMDArMDA6MDAifQ',
  'barka-sayal': 'RzBFAiBt2BzyG0OqWWhcz6ypxsk-L3DZXbkm2fITGW-NfOy5hwIhAMrtUho0zoYSDj88iAvxJJk4DoHzMI3vLW9e9yEbH7mYeyJ1Ijo0LCJlIjoiMjAzMC0xMi0zMFQxODozMDowMC4wMDArMDA6MDAifQ',
  'barkasayal': 'RzBFAiBt2BzyG0OqWWhcz6ypxsk-L3DZXbkm2fITGW-NfOy5hwIhAMrtUho0zoYSDj88iAvxJJk4DoHzMI3vLW9e9yEbH7mYeyJ1Ijo0LCJlIjoiMjAzMC0xMi0zMFQxODozMDowMC4wMDArMDA6MDAifQ',
  'north-karanpura': 'RzBFAiBu3K0HUyrZQPG3o1EG5fQRSDN7jLR-LwGlmnTENm9bPQIhAPURArvxXS-xgNNPfJeqGRIvT64PIY-xRQBYcNmgDI--eyJ1Ijo2LCJlIjoiMjAzMC0xMi0zMFQxODozMDowMC4wMDArMDA6MDAifQ',
  'northkaranpura': 'RzBFAiBu3K0HUyrZQPG3o1EG5fQRSDN7jLR-LwGlmnTENm9bPQIhAPURArvxXS-xgNNPfJeqGRIvT64PIY-xRQBYcNmgDI--eyJ1Ijo2LCJlIjoiMjAzMC0xMi0zMFQxODozMDowMC4wMDArMDA6MDAifQ',
  'bokaro-kargali': 'SDBGAiEAs2bK2zdy1HOuiGGHxM1QPkvfgPK_vkOV9qaIimRBpygCIQCx6EVTWSCMsSC_5Ju5yle77iVoxXK865-cfBkv82pyN3sidSI6NywiZSI6IjIwMzAtMTItMzBUMTg6MzA6MDAuMDAwKzAwOjAwIn0',
  'bokarokargali': 'SDBGAiEAs2bK2zdy1HOuiGGHxM1QPkvfgPK_vkOV9qaIimRBpygCIQCx6EVTWSCMsSC_5Ju5yle77iVoxXK865-cfBkv82pyN3sidSI6NywiZSI6IjIwMzAtMTItMzBUMTg6MzA6MDAuMDAwKzAwOjAwIn0',
  'kathara': 'RjBEAiBkfyZ951QhLlpIlh856RFi84ZHhOXI-sFZnErdDqCtfgIgF6xmpfktuTijulk_PdVokj9f7J8ItdYeWe-iriBaLyR7InUiOjgsImUiOiIyMDMwLTEyLTMwVDE4OjMwOjAwLjAwMCswMDowMCJ9',
  'giridih': 'RjBEAiBlebAlkhTpfS4JuGbnwh9p3BTjGVlCxmmeK8VXwJBYUAIgYWYCz-ULy2r9bhSV4AL5M6pFGlOcd8skrT-IyH28F-97InUiOjksImUiOiIyMDMwLTEyLTMwVDE4OjMwOjAwLjAwMCswMDowMCJ9',
  'amrapali-chandragupta': 'RjBEAiAiX7tO5v_Up5ZsaV11zthCTGx0lQkA0T1DZrSvADG0wAIgbkIl-H0v_4NqfOHu9smLSElZoEMd3qAAr2Uv0PN-Z7Z7InUiOjEwLCJlIjoiMjAzMC0xMi0zMFQxODozMDowMC4wMDArMDA6MDAifQ',
  'amrapali': 'RjBEAiAiX7tO5v_Up5ZsaV11zthCTGx0lQkA0T1DZrSvADG0wAIgbkIl-H0v_4NqfOHu9smLSElZoEMd3qAAr2Uv0PN-Z7Z7InUiOjEwLCJlIjoiMjAzMC0xMi0zMFQxODozMDowMC4wMDArMDA6MDAifQ',
  'magadh-sanghmitra': 'RzBFAiAG4SwViIzjziTxvKXkXcpaGsz517WGNfcHEU-fj2shOQIhAKl9pJ0tuGuNRXSnRJ6ELavr67RwJGeGTjsZ_NMQM3NFeyJ1IjoxMSwiZSI6IjIwMzAtMTItMzBUMTg6MzA6MDAuMDAwKzAwOjAwIn0',
  'magadh': 'RzBFAiAG4SwViIzjziTxvKXkXcpaGsz517WGNfcHEU-fj2shOQIhAKl9pJ0tuGuNRXSnRJ6ELavr67RwJGeGTjsZ_NMQM3NFeyJ1IjoxMSwiZSI6IjIwMzAtMTItMzBUMTg6MzA6MDAuMDAwKzAwOjAwIn0',
  'rajhara': 'RzBFAiBiYtIy1uHkXaW77VoQEJEizhNAc6jBu8LcpUbyoCDDagIhAIYmqfB_fMJCcDVYsDYPOpSUR3y9JGcQL4eExS4XymmDeyJ1IjoxMiwiZSI6IjIwMzAtMTItMzBUMTg6MzA6MDAuMDAwKzAwOjAwIn0',
  'kuju': 'RzBFAiEAudObmgIOoBbRNrIqu9R3By9SxfxVdCqMMpDJFMkAkZsCIH406bp2wBFuR4DZESJVX9GnGsLgCG-PWHZyol4dsAQVeyJ1IjoxMywiZSI6IjIwMzAtMTItMzBUMTg6MzA6MDAuMDAwKzAwOjAwIn0',
  'hazaribagh': 'SDBGAiEAusm6x-BRH7dabxwdUWPjc7aGtuwOC2OIKudkHSQ9X6oCIQCSezww062I13AK9sWOi5Xb6xnUQWys-ypPxaKyouPGxXsidSI6MTQsImUiOiIyMDMwLTEyLTMwVDE4OjMwOjAwLjAwMCswMDowMCJ9',
  'rajrappa': 'SDBGAiEA1Y6mtsuOajNMPeLASRAzQ7lagpN_Sqk2Hg3YKuJ1IB0CIQCCYe63y24h-JfJ2GkgGciOTBZnoMzJz1XVjN3pIZt1I3sidSI6MTUsImUiOiIyMDMwLTEyLTMwVDE4OjMwOjAwLjAwMCswMDowMCJ9',
  'dhori': 'RzBFAiBhIeF3Etb7_m5eDX2B2lyDlIqBpt5FFDA9dPd9YAkhrQIhAMRDEHu07S8hBb2Gfqi4Oi3p5REFIglyi8izf-vLB25peyJ1IjoxNiwiZSI6IjIwMzAtMTItMzBUMTg6MzA6MDAuMDAwKzAwOjAwIn0',
  'piparwar': 'RjBEAiANIMKdspTHpc5gtJ9_RWmj3S0BVfphYwdH0cnsRXOMRgIgVfdB8K7u6VTR4tLF5-64-tcQF3za42l1A7GpUXe8IDV7InUiOjE3LCJlIjoiMjAzMC0xMi0zMFQxODozMDowMC4wMDArMDA6MDAifQ'
};

const AREA_DISPLAY_NAMES = {
  'argada': 'Argada',
  'barka-sayal': 'Barka Sayal',
  'north-karanpura': 'North Karanpura',
  'bokaro-kargali': 'Bokaro & Kargali',
  'kathara': 'Kathara',
  'giridih': 'Giridih',
  'amrapali-chandragupta': 'Amrapali & Chandragupta',
  'magadh-sanghmitra': 'Magadh & Sanghmitra',
  'rajhara': 'Rajhara',
  'kuju': 'Kuju',
  'hazaribagh': 'Hazaribagh',
  'rajrappa': 'Rajrappa',
  'dhori': 'Dhori',
  'piparwar': 'Piparwar'
};

const TOKEN_STORAGE_KEY = 'ccl_auth_token';
const AREA_STORAGE_KEY = 'ccl_auth_area';
const SESSION_TIMEOUT = 60* 60 * 1000; 

/**

 * @param {string} token 
 * @param {string} area - The area associated with the token (null for admin)
 */
const storeTokenSecurely = (token, area = null) => {
  try {
    const tokenData = {
      token: token,
      area: area, 
      isAdmin: !area,
      timestamp: Date.now(),
      expiresAt: Date.now() + SESSION_TIMEOUT
    };
    
    localStorage.setItem(TOKEN_STORAGE_KEY, JSON.stringify(tokenData));
    if (area) {
      localStorage.setItem(AREA_STORAGE_KEY, area);
    } else {
      localStorage.removeItem(AREA_STORAGE_KEY);
    }
    console.log('🔒 Token stored securely in localStorage', area ? `for area: ${area}` : '(Admin access)');
    
    const url = new URL(window.location);
    url.searchParams.delete('token');
    window.history.replaceState({}, document.title, url.pathname + url.search);
    
    console.log('🧹 Token removed from URL');
  } catch (error) {
    console.error('❌ Error storing token:', error);
  }
};

/**
 * Retrieves the stored token
 * @returns {string|null} The stored token if valid, null otherwise
 */
const getStoredToken = () => {
  try {
    const storedData = localStorage.getItem(TOKEN_STORAGE_KEY);
    
    if (!storedData) {
      console.log('📭 No stored token found in localStorage');
      return null;
    }
    
    const tokenData = JSON.parse(storedData);
    
  // Here we check if the token has expired all thanks to thala

    if (Date.now() > tokenData.expiresAt) {
      console.log('⏰ Stored token has expired, removing...');
      localStorage.removeItem(TOKEN_STORAGE_KEY);
      return null;
    }
    
    console.log('✅ Stored token is still valid');
    return tokenData.token;
  } catch (error) {
    console.error('❌ Error retrieving stored token:', error);
    return null;
  }
};

/**
 * Validates the authentication token
 * @param {string} token - The token to validate
 * @returns {object|null} Returns {isValid: boolean, isAdmin: boolean, area: string|null} or null if invalid
 */

const isValidToken = (token) => {
  if (ADMIN_TOKENS.includes(token)) {
    return { isValid: true, isAdmin: true, area: null };
  }
  
  for (const [areaKey, areaToken] of Object.entries(AREA_TOKENS)) {
    if (token === areaToken) {
      if (areaKey === 'barkasayal' || areaKey === 'northkaranpura' || areaKey === 'bokarokargali' || areaKey === 'amrapali') {
        continue;
      }
      return { isValid: true, isAdmin: false, area: areaKey };
    }
  }
  
  return null;
};

/**
 * Gets token from URL or storage and validates it
 * @returns {object|null} Returns {authenticated: boolean, isAdmin: boolean, area: string|null} or null
 */
export const validateAuthentication = () => {
  try {
    const urlParams = new URLSearchParams(window.location.search);
    const urlToken = urlParams.get('token');
    
    if (urlToken) {
      console.log('🔑 Token found in URL, validating...');
      const validationResult = isValidToken(urlToken);
      if (validationResult && validationResult.isValid) {
        console.log('✅ URL token is valid, storing securely...');
        storeTokenSecurely(urlToken, validationResult.area);
        return { authenticated: true, isAdmin: validationResult.isAdmin, area: validationResult.area };
      } else {
        console.log('❌ URL token is invalid');
        const url = new URL(window.location);
        url.searchParams.delete('token');
        window.history.replaceState({}, document.title, url.pathname + url.search);
        return { authenticated: false, isAdmin: false, area: null };
      }
    }
    
    // No token in URL, check stored token (important takki attack na ho)
    console.log('🔍 No token in URL, checking stored token...');
    const storedToken = getStoredToken();
    
    if (storedToken) {
      const validationResult = isValidToken(storedToken);
      if (validationResult && validationResult.isValid) {
        console.log('✅ Stored token is valid - user is authenticated');
        return { authenticated: true, isAdmin: validationResult.isAdmin, area: validationResult.area };
      }
    }
    
    console.log('❌ No valid stored token found');
    return { authenticated: false, isAdmin: false, area: null };
    
  } catch (error) {
    console.error('Error validating authentication:', error);
    return { authenticated: false, isAdmin: false, area: null };
  }
};

export const redirectIfInvalid = () => {
  const authResult = validateAuthentication();
  if (!authResult.authenticated) {
    console.log('🚨 Authentication failed, redirecting to cclai.in...');
    localStorage.removeItem(TOKEN_STORAGE_KEY);
    localStorage.removeItem(AREA_STORAGE_KEY);
    window.location.href = 'https://cclai.in';
  } else {
    console.log('🎉 Authentication successful!', authResult.isAdmin ? '(Admin)' : `(Area: ${authResult.area})`);
  }
};

export const logout = () => {
  try {
    localStorage.removeItem(TOKEN_STORAGE_KEY);
    localStorage.removeItem(AREA_STORAGE_KEY);
    console.log('👋 User logged out');
    window.location.href = 'https://cclai.in';
  } catch (error) {
    console.error('Error during logout:', error);
    window.location.href = 'https://cclai.in';
  }
};

/**
 * Checks if user is currently authenticated
 * @returns {object} Returns {authenticated: boolean, isAdmin: boolean, area: string|null}
 */
export const isAuthenticated = () => {
  const authResult = validateAuthentication();
  return {
    authenticated: authResult.authenticated,
    isAdmin: authResult.isAdmin,
    area: authResult.area
  };
};

/**
 * Gets the current authentication status and remaining session time
 * @returns {object} Authentication status object
 */
export const getAuthStatus = () => {
  try {
    const storedData = localStorage.getItem(TOKEN_STORAGE_KEY);
    
    if (!storedData) {
      return { authenticated: false, remainingTime: 0, isAdmin: false, area: null };
    }
    
    const tokenData = JSON.parse(storedData);
    const now = Date.now();
    const remainingTime = Math.max(0, tokenData.expiresAt - now);
    
    const validationResult = isValidToken(tokenData.token);
    const isValid = validationResult && validationResult.isValid;
    
    return {
      authenticated: remainingTime > 0 && isValid,
      remainingTime: remainingTime,
      expiresAt: new Date(tokenData.expiresAt).toISOString(),
      isAdmin: tokenData.isAdmin || false,
      area: tokenData.area || null,
      areaDisplayName: tokenData.area ? AREA_DISPLAY_NAMES[tokenData.area] : null
    };
  } catch (error) {
    console.error('Error getting auth status:', error);
    return { authenticated: false, remainingTime: 0, isAdmin: false, area: null };
  }
};


export const extendSession = () => {
  try {
    const storedToken = getStoredToken();
    const storedData = localStorage.getItem(TOKEN_STORAGE_KEY);
    if (storedToken && storedData) {
      const tokenData = JSON.parse(storedData);
      storeTokenSecurely(storedToken, tokenData.area || null); // This will reset the timestamp
      return true;
    }
    return false;
  } catch (error) {
    console.error('Error extending session:', error);
    return false;
  }
};

/**
 * Gets the logged-in area
 * @returns {string|null} The area name (normalized) or null if admin
 */
export const getLoggedInArea = () => {
  const authStatus = getAuthStatus();
  return authStatus.area || null;
};

/**
 * Gets the display name of the logged-in area
 * @returns {string} The area display name or 'All Areas' if admin
 */
export const getAreaDisplayName = () => {
  const authStatus = getAuthStatus();
  if (authStatus.isAdmin) {
    return 'All Areas';
  }
  return authStatus.areaDisplayName || 'Unknown Area';
};

/**
 * Checks if user is admin
 * @returns {boolean}
 */
export const isAdminUser = () => {
  const authStatus = getAuthStatus();
  return authStatus.isAdmin;
};

/**
 * Gets the current authentication token
 * @returns {string|null} The current token if authenticated, null otherwise
 */
export const getCurrentToken = () => {
  return getStoredToken();
};

/**
 * Gets the analytics dashboard URL with token parameter if available
 * @returns {string} The analytics dashboard URL with or without token
 */
export const getAnalyticsDashboardUrl = () => {
  const baseUrl = 'https://cclai.in/dashboard-analytics-k.php';
  const token = getCurrentToken();
  
  if (token) {
    return `${baseUrl}?token=${encodeURIComponent(token)}`;
  }
  
  return baseUrl;
};